import { useUserInfo } from "@redux/slices/userInfoSlice";

export const useAvailabilityData = (priceModeArr: number[]) => {
  const userInfo = useUserInfo();
  const priceMode = userInfo?.user?.price_mode;
  if (!priceModeArr || priceModeArr.length === 0) return false;
  return priceModeArr.includes(priceMode);
};
